import { DataGrid, GridColDef } from '@material-ui/data-grid';
import { useMemo } from 'react';
import styled from 'styled-components';
import Grid from '../Grid';

interface IProps {
  headerItems: Omit<GridColDef, 'field'>[];
  bodyItems?: any[][];
}

const GridTag = styled(Grid)`
  height: 600px;
  overflow-y: scroll;
  border: 1px solid #e2e2e2;
  border-radius: 5px;
`;

export default function TableComponent(props: IProps) {
  const columns = useMemo(
    () =>
      props.headerItems.map((one, index) => ({
        sortable: false,
        disableColumnMenu: true,
        ...one,
        field: `col${index}`,
      })),
    [props.headerItems],
  );

  const rows = useMemo(
    () =>
      props.bodyItems
        ? props.bodyItems.map((row, index) =>
            row.reduce((all, current, index2) => {
              all.id = index;
              all[`col${index2}`] = current;
              return all;
            }, {}),
          )
        : [],
    [props.bodyItems],
  );

  return (
    <>
      <GridTag>
        <DataGrid columns={columns} rows={rows} hideFooter />
      </GridTag>
    </>
  );
}
